import { render, staticRenderFns } from "./TableCompetitorConfig.vue?vue&type=template&id=7d3c0e4d&scoped=true"
import script from "./TableCompetitorConfig.vue?vue&type=script&lang=js"
export * from "./TableCompetitorConfig.vue?vue&type=script&lang=js"
import style0 from "./TableCompetitorConfig.vue?vue&type=style&index=0&id=7d3c0e4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3c0e4d",
  null
  
)

export default component.exports